export function createSvgAndSvgObjects(name, ...attrs) {
  const el = document.createElementNS("http://www.w3.org/2000/svg", name);
  setAttrToSvgObjects(el, ...attrs);
  return el;
}

export function setAttrToSvgObjects(el, ...attrs) {
  attrs.filter(Boolean).forEach(a => (a.length === 3 ? el.setAttributeNS(...a) : el.setAttribute(...a)));
}
